export default {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  PLANNED: 'PLANNED',
  STOPPED: 'STOPPED',
  ARCHIVED: 'ARCHIVED',
};
